import Vue from 'vue'
import VueRouter from 'vue-router'
import objects from './objects'
import apartments from './apartments'
// import { canNavigate } from '@/libs/acl/routeProtection'
import {
  isUserLoggedIn
} from '@/auth/utils'
import Clients from './Clients'
import Kanban from './Kanban'
import sms from './sms'
import references from './references'
import contracts from './contracts'
import finance from './finance'
import administration from './administration'
// import ability from '@/libs/acl/ability'
import store from '@/store'
import useJwt from '@/auth/jwt/useJwt'
import reports from './reports'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  },
  routes: [
    ...objects,
    ...apartments,
    ...Clients,
    ...Kanban,
    ...finance,
    ...sms,
    ...references,
    ...contracts,
    ...administration,
    ...reports,
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/modules/MyObjects/index.vue'),
      meta: {
        pageTitle: '',
        breadcrumb: [{
          text: 'Учет объектов',
          active: true,
        }, ],
      },
    },
    {
      path: '/second-page',
      name: 'second-page',
      component: () => import('@/views/SecondPage.vue'),
      meta: {
        pageTitle: 'Second Page',
        breadcrumb: [{
          text: 'Second Page',
          active: true,
        }, ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        action: 'read',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  // Redirect to login if not logged in
  if (to.name !== 'login') {
    if (!isLoggedIn) {
      return next('/login')
    }
    if (to.meta.unique_name && !store.getters['permission/check'](to.meta.unique_name)) {
      return next('/error-404');
    }
  }

  next()
})

// ? For splash screen
router.afterEach(() => {
  // Remove initial loading
  let permission = []
  if (useJwt.getUserData() && !store.state.users.permissions.length) {
    if (useJwt.getUserData().is_superuser) {
      permission = ['content_management', 'admin', 'sales_management', 'finance_management', 'user_management']
    } else {
      permission = useJwt.getUserData().permission
    }
    store.commit('users/SET_USER_PERMISSIONS', permission)
  }
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router